import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import "rxjs/add/operator/map";
import { tokenNotExpired } from 'angular2-jwt';
import { environment } from '../../environments/environment';

@Injectable()
export class CalculatorService {

  public token: any;
  
  public serverUrl = environment.apiserver

  constructor(
    public http: Http
  ){}

    executeCalculator(wire){
      console.log("cal")
      let headers = new Headers();
      headers.append('Content-Type', 'application/json');
      let api = this.serverUrl + "/api/wire/calculate";
      return this.http.post(api, wire , {headers: headers}).map(res => res.json());
    }

    getInstallationMethods(wireType){
      let headers = new Headers();
      headers.append('Content-Type', 'application/json');
      let api = this.serverUrl +"/api/wire/getinstallationmethod";
      return this.http.post(api, wireType , {headers: headers}).map(res => res.json());
    }

    getSetting(){debugger;
      let api = this.serverUrl + "/api/wire/getsetting";
      let headers = new Headers();
      headers.append('Content-Type', 'application/json');
      return this.http.post(api, null , {headers: headers}).map(res => res.json());
    }

    saveResultRecord(id: string, data: any){debugger;
      let api = this.serverUrl + "/api/searchDetail/create/"+ id;
      let headers = new Headers();
      headers.append('Content-Type', 'application/json');  
      return this.http.post(api, data, {headers: headers}).map(res => res.json());
    }

    getUserSearchHistory(id: string){debugger;
      let api = this.serverUrl + "/api/searchHistory/user/"+ id;
      let headers = new Headers();
      headers.append('Content-Type', 'application/json');
      return this.http.get(api, {headers: headers}).map(res => res.json());
    }

  }



// WEBPACK FOOTER //
// ./src/app/services/calculator.service.ts